import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ExpenseWarning from "@MasterBluePrint/Icons/ExpenseWarning";
import WarningNotification from "@MasterBluePrint/Icons/WarningNotification";
import { getCurrentWebsiteCountry } from "@MasterBluePrint/Services/CurrentWebsiteCountryService";
import parse from "html-react-parser";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    fields: {
        messageTitle: string;
        messageText: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const cartState = getCurrentCartState(state);
    const shipToState = getShipToState(state, cartState.value?.shipToId);
    return {
        fields: ownProps.fields,
        shipToCountry: shipToState.value?.country?.abbreviation
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface NotificationStyles {
    exportExpensesCSS?: InjectableCss;
}

export const notificationStyles: NotificationStyles = {
    exportExpensesCSS: {
        css: css`
            box-sizing: border-box;
            height: auto;
            max-width: 98.5%;
            border: 1px solid #FFDEB2;
            border-radius: 2px;
            background-color: #FFEFD9;
            margin-top: 1rem;
        `,
    },
};

const styles = notificationStyles;

const ExportExpense: FC<Props> = ({
    fields,
    shipToCountry
}) => {
    const [currentWebsiteCountry, setcurrentWebsiteCountry] = useState("");
    useEffect(() => {
        getCurrentWebsiteCountry().then(response => {
            setcurrentWebsiteCountry(response);
        });
    }, []);

    if(shipToCountry?.toLowerCase() !== currentWebsiteCountry.toLowerCase()) {
        return  (
            <StyledWrapper {...styles.exportExpensesCSS}>
                        <div
                            style={{
                                height: "auto",
                                width: "auto",
                                color: "#2E384D",
                                fontFamily: "Roboto",
                                fontSize: "20px",
                                letterSpacing: 0,
                                lineHeight: "26px",
                                padding: "0.75rem",
                            }}
                        >
                            <Icon
                                src={ExpenseWarning}
                                css={css`
                                    height: 32px;
                                    width: 32px;
                                    vertical-align: middle;
                                `}
                                style={{ fill: "#C63527" }}
                            />
                            <Typography>{parse(fields.messageTitle, parserOptions)}</Typography>
                        </div>
                        <div
                            style={{
                                height: "1px",
                                maxWidth: "100%",
                                backgroundColor: "#C2D1D9",
                            }}
                        ></div>
                        <div
                            style={{
                                height: "auto",
                                width: "auto",
                                color: "#2E384D",
                                fontFamily: "Lato",
                                fontSize: "16px",
                                letterSpacing: 0,
                                lineHeight: "24px",
                                padding: "1rem",
                            }}
                        >
                            <Typography>{parse(fields.messageText, parserOptions)}</Typography>
                        </div>
                    </StyledWrapper>
        );
    }
    return <div></div>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ExportExpense),
    definition: {
        fieldDefinitions: [
            {
                name: "messageTitle",
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                defaultValue: "Please Note",
                isRequired: true,
                displayName: "Message Title",
            },
            {
                name: "messageText",
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                defaultValue: "You are responsible at your own expense for obtaining any import or export license or any other documentation deemed necessary by any competent authority. You may be required to pay import duties before delivery is complete.",
                isRequired: true,
                displayName: "Message",
            },
        ],
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;
